import { render } from "./Quote.vue?vue&type=template&id=d7280c86&scoped=true&ts=true"
import script from "./Quote.vue?vue&type=script&lang=ts"
export * from "./Quote.vue?vue&type=script&lang=ts"

import "./Quote.vue?vue&type=style&index=0&id=d7280c86&scoped=true&lang=scss"

import exportComponent from "/Users/saschas/dev/neurocure_website/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7280c86"]])

export default __exports__